export var getIsItemAddedModalOpen = function getIsItemAddedModalOpen(state) {
  return Boolean(state.itemId) && (Boolean(state.productId) || Boolean(state.productCode));
};